module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_16.b0ada42b.jpg";